import { Link } from "react-router-dom";
import ArticleCard from "@/components/feature/ArticleCard";
import { articles } from "@/mocks/articles";

export default function LatestArticles() {
  const featured = articles.filter((a) => a.featured).slice(0, 3);
  const others = articles.filter((a) => !featured.includes(a)).slice(0, 3);

  return (
    <section className="border-y border-background-200 bg-background-100/60 py-12 md:py-16">
      <div className="container-x">
        <div className="flex items-end justify-between gap-4">
          <div>
            <p className="text-xs font-medium tracking-widest text-primary-600">最新更新</p>
            <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">最新剧情讨论</h2>
            <p className="mt-2 max-w-xl text-sm text-foreground-500">
              宗门篇、修炼境界、主线走向与伏笔盘点，新文章第一时间整理给你。
            </p>
          </div>
          <Link
            to="/section/zhuxian"
            className="hidden items-center gap-1 whitespace-nowrap text-sm text-primary-600 hover:text-primary-700 sm:flex"
          >
            更多讨论
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-5 md:grid-cols-3">
          {featured.map((a) => (
            <ArticleCard key={a.id} article={a} />
          ))}
        </div>

        <div className="mt-8 grid grid-cols-1 gap-4 border-t border-background-200/70 pt-6 sm:grid-cols-2 lg:grid-cols-3">
          {others.map((a) => (
            <article key={a.id} className="group flex items-start gap-4">
              <Link to={`/article/${a.slug}`} className="block w-28 shrink-0 overflow-hidden rounded-lg" aria-label={a.title}>
                <div className="aspect-[4/3] w-full">
                  <img
                    src={a.cover}
                    alt={`${a.title} 封面配图`}
                    className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
                  />
                </div>
              </Link>
              <div className="flex flex-1 flex-col">
                <span className="text-xs text-primary-600">{a.categoryName}</span>
                <h3 className="mt-1 font-heading text-sm font-semibold leading-snug text-foreground-950">
                  <Link to={`/article/${a.slug}`} className="transition-colors hover:text-primary-700">
                    {a.title}
                  </Link>
                </h3>
                <p className="mt-1.5 line-clamp-2 text-xs leading-relaxed text-foreground-500">{a.excerpt}</p>
                <p className="mt-2 flex items-center gap-2 text-xs text-foreground-400">
                  <span>{a.author}</span>
                  <span className="h-1 w-1 rounded-full bg-foreground-300"></span>
                  <span>{a.date}</span>
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}